/** Router component */
import React, { useEffect } from 'react';
import loadable from '@loadable/component';
import { Switch, Route } from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import GlobalSnackbar from '../components/atom/globalSnackbar';
import Loader from './organism/loader';


const tagManagerArgs = {
    gtmId: "GTM-57GKC3W"
};


const RegistrationFunctional = loadable(() => import('./pages/registration/regFunctional'));
const DAD = loadable(() => import('./pages/dad'));
const SessionExpire = loadable(() => import('./pages/sessionExpire'));
const MultiSession = loadable(() => import('./pages/multiSession'));
const Continue = loadable(() => import('./pages/continue'));

let GA_TRACKING_CODE = process.env.REACT_APP_GA_TRACKING_CODE;

const Router = () => {


    // useEffect(() => {
    //     const redirectCases = ['alliance', 'mfd', 'insurance', 'nonbroking'];
    //     const pathname = window.location.pathname.toLowerCase();
    //     const host = window.location.host.toLowerCase();

    //     const hasRedirectCase = redirectCases.some(redirectCase =>
    //         pathname.includes(`/${redirectCase}`)
    //     );

    //     if (hasRedirectCase) {
    //         const needsHostChange = !host.includes('ekyc.motilaloswal.com');
    //         const needsPathChange = pathname.includes('/open-demat-account/');

    //         if (needsHostChange || needsPathChange) {
    //             const newHost = 'ekyc.motilaloswal.com';
    //             const newPath = needsPathChange
    //                 ? window.location.pathname.replace(/\/open-demat-account\//i, '/partner/')
    //                 : window.location.pathname;

    //             window.location.href = `https://${newHost}${newPath}${window.location.search}${window.location.hash}`;
    //         }
    //     }
    // }, []);



    return (
        <>
            <Loader />
            <GlobalSnackbar />
            <Switch>
                <Route exact path="/">
                    <RegistrationFunctional showMFDReg={false} />
                </Route>
                <Route path="/mobileOTP">
                    <RegistrationFunctional
                        showOTP={true}
                        showMFDOtp={false}
                    />
                </Route>

                <Route path={'/dad'}>
                    <DAD />
                </Route>


                <Route path={'/sessionExpire'}>
                    <SessionExpire />
                </Route>

                <Route path={'/multiSession'}>
                    <MultiSession />
                </Route>

                {/* Assisted-journey 2nd-device resume landing (TKT-0045). Public,
                    no /dad guard — resolves the short code, then Flow A hands off
                    to the registration page (prefilled) and Flow B exchanges the
                    code for a session. */}
                <Route path={'/continue/:shortCode'}>
                    <Continue />
                </Route>
            </Switch>
        </>
    );
}

export default process.env.NODE_ENV === "development" ? hot(Router) : Router;
